'use client';

import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-sm mb-4">
      <Link href="/network-dashboard" className="text-muted-color hover:text-secondary-color transition-colors flex-shrink-0">
        <Icon name="HomeIcon" size={14} />
      </Link>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          <Icon name="ChevronRightIcon" size={12} className="text-muted-color flex-shrink-0" />
          {item.href && index < items.length - 1 ? (
            <Link
              href={item.href}
              className="text-muted-color hover:text-secondary-color transition-colors truncate max-w-[160px]"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-secondary-color font-semibold truncate max-w-[200px]">
              {item.label}
            </span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}
